import { Collection, Document } from 'firestorter';
import { firestorePaths } from '../utils/paths';
import BaseDocument from './BaseDocument';

class CoachPod extends BaseDocument {
  get name() {
    return this.data.name;
  }

  get userCount() {
    return this.data.userCount;
  }

  get coach() {
    return this.data.coach;
  }

  static async create(coach, name) {
    const coachPodCollection = new Collection(firestorePaths.COACH_POD);

    const pod = await coachPodCollection.add({
      coach,
      name,
      userCount: 0,
      createdAt: new Date(),
    });

    return pod.id;
  }

  static async delete(podId) {
    const coachPodDoc = new Document(`${firestorePaths.COACH_POD}/${podId}`);

    await coachPodDoc.delete();
  }

  static async getAllPods() {
    const coachCollection = new Collection(firestorePaths.COACH_POD, {
      createDocument: (source, options) => new CoachPod(source, options),
    });
    await CoachPod.initCollection(coachCollection);

    return coachCollection;
  }

  static async getPodsByCoach(coachId) {
    const coachCollection = new Collection(firestorePaths.COACH_POD, {
      createDocument: (source, options) => new CoachPod(source, options),
      query: (query) => query
        .where('coach', '==', coachId)
        .orderBy('name', 'asc')
      ,
    });
    await CoachPod.initCollection(coachCollection);

    return coachCollection;
  }
}

export default CoachPod;
